<div class="input-container">
    <button *ngFor="let value of values" [class.active]="currentValue === value" (click)="changedValue(value)">{{value | formatDecimal: 1 }}m</button>
</div>
